import { useEffect } from "react";
import { Dashboard } from "src/components/dashboard";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = ""

const DashboardPage = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <Dashboard />
        </div>
      </div>
    </div>
  );
};

export { DashboardPage };